<ng-container *transloco="let t;">
  <app-detail-view [loading]="loading" [messages]="messages" (closed)="onClose()">

    <div title>
      <h1>
        <span *ngIf="newMode()">{{ t('common.labels.create_ratingtype') }}</span>
        <span *ngIf="editMode()">{{ t('common.labels.ratingtype') }} <strong>{{ ratingtype.getLang('name', transloco.getActiveLang()) }}</strong></span>
      </h1>
    </div>

    <div details>
      <p-tabView>

          <p-tabPanel header="{{ t('common.labels.basedata') }}" leftIcon="pi pi-sliders-h">
            <app-ratingtype-new *ngIf="newMode()"></app-ratingtype-new>
            <app-ratingtype-basedata *ngIf="editMode()" [ratingtype]="ratingtype"></app-ratingtype-basedata>
          </p-tabPanel>

      </p-tabView>
    </div>

  </app-detail-view>
</ng-container>
